import {NgModule} from '@angular/core';

import {ResultatExamenDossierTableComponent} from './resultat-examen-dossier-table.component';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {PrescriptionRealisePharmacieDetailTableModule} from '@app/fonctionnalites/dossier-medical-prestation/composants/prescription-dossier-table/prescription-realise-pharmacie-detail-table/prescription-realise-pharmacie-detail-table.module';
import {ResultatDetailTableModule} from '@app/fonctionnalites/dossier-medical-prestation/composants/resultat-examen-dossier-table/resultat-detail-table/resultat-detail-table.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        PrescriptionRealisePharmacieDetailTableModule,
        ResultatDetailTableModule,
    ],
  exports: [ResultatExamenDossierTableComponent],
  declarations: [ResultatExamenDossierTableComponent],
  providers: [],
})
export class ResultatExamenDossierTableModule {
}
